import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

// App
import { FormikField, FormikFieldSelect } from "../../core/components/formik";
import { validateRequired } from "../../../utilities/validators";

const OrganizationLocationFieldset = (props) => {
  const { formDataParents, formDataOrganizations } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <FormikFieldSelect
        label={t("title.organization")}
        name="idOrganization"
        options={formDataOrganizations}
        optionsKeyLabel="nameComposed"
        optionsKeyValue="id"
        required
        validate={validateRequired}
      />
      <FormikField label={t("title.name")} name="name" required validate={validateRequired} />
      <FormikFieldSelect
        label={t("title.parent")}
        name="idParent"
        options={formDataParents}
        optionsKeyLabel="nameComposed"
        optionsKeyValue="id"
      />
    </Fragment>
  );
};

OrganizationLocationFieldset.propTypes = {
  formDataOrganizations: PropTypes.array.isRequired,
  formDataParents: PropTypes.array.isRequired,
};

export default OrganizationLocationFieldset;
